var map = {
	"./fonts/hk-grotesk.bold.ttf": "de2d",
	"./fonts/hk-grotesk.light.ttf": "1c86",
	"./fonts/hk-grotesk.medium.ttf": "4cbf",
	"./fonts/hk-grotesk.regular.ttf": "33c5",
	"./fonts/hk-grotesk.semibold.ttf": "79fa",
	"./logo.png": "d1c2",
	"./pdf_icon.svg": "6cea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17719";